import { render, staticRenderFns } from "./FormulasList.vue?vue&type=template&id=ed3a9b76&"
import script from "./FormulasList.vue?vue&type=script&lang=js&"
export * from "./FormulasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports